module.exports = __webpack_public_path__ + "3fac313f5a20d93d24be75ca7930031f.svg";